let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6sXO4")).then(() => parcelRequire('gg9qV'));